import { IController, IFilterService } from 'angular';
import { each, every, reduce } from 'lodash';

import { ManageUsersCreateOrEditUserModal } from './../manage-users-modals/create-or-edit-user/manage-users-create-or-edit-user-modal.service';
import { IManageUsersSchool, IManageUsersSharedState, IManageUsersUser } from './../manage-users.controller';

export class ManageUsersTableCtrl implements IController {
  static $inject: string[] = ['ManageUsersCreateOrEditUserModal', '$filter', 'Rollbar'];

  // bindings
  getSelectedUsers;
  school: IManageUsersSchool;
  schoolUsers;
  sharedState: IManageUsersSharedState;
  updateSchoolUser;
  users: IManageUsersUser[];
  usersSortCache;

  // class properties
  public everyUserIsSelected: boolean;
  public activeSort: string;
  public reverseSort: boolean;

  constructor(
    private manageUsersCreateOrEditUserModal: ManageUsersCreateOrEditUserModal,
    private $filter: IFilterService,
    private Rollbar,
  ) {}

  public $onInit() {
    this.everyUserIsSelected = false;

    // sort by name in ascending order
    this.sortBy('name');
  }

  public $onChanges(changesObj) {
    const { users } = changesObj;

    if (users && this.usersSortCache) {
      // keeps sort order in place when users are updated or added
      this.users.sort((a, b) => {
        const aOrder = this.usersSortCache[a._id];
        const bOrder = this.usersSortCache[b._id];

        return aOrder - bOrder;
      });
    }
  }

  public isToggleAllUsersIndeterminate(): boolean {
    const atLeastOneUserIsSelected = this.isAtLeastOneUserSelected(this.users);
    const everyUserIsSelected = (this.everyUserIsSelected = this.isEveryUserSelected(
      this.users,
      atLeastOneUserIsSelected,
    ));
    const indeterminate = atLeastOneUserIsSelected && !everyUserIsSelected;

    return indeterminate;
  }

  public showUpdateUserModal(user: IManageUsersUser) {
    this.manageUsersCreateOrEditUserModal
      .show(this.school, user, this.schoolUsers)
      .then(results => {
        if (results) {
          const { updatedSchoolUser } = results;

          if (updatedSchoolUser) {
            this.updateSchoolUser({
              updatedSchoolUser,
            });
          }
        }
      })
      .catch(err => {
        this.Rollbar.error(`Unable to update school user: `, err);
      });
  }

  public toggleAllUsers(): void {
    const selected = (this.everyUserIsSelected = !this.everyUserIsSelected);

    each(this.users, u => {
      // do not toggle users with 'School Admin' - this role cannot be edited
      if (u.editable && u.filtered) {
        u.selected = selected;
      }
    });
  }

  public sortBy(fieldName: string) {
    const newActiveSortExists = this.activeSort !== fieldName;

    if (newActiveSortExists) {
      this.activeSort = fieldName;
      this.reverseSort = false;
    } else {
      this.reverseSort = !this.reverseSort;
    }

    this.users = this.$filter('orderBy')(this.users, fieldName, this.reverseSort);
    this.usersSortCache = reduce(
      this.users,
      (acc, u, indx) => {
        acc[u._id] = indx;
        return acc;
      },
      {},
    );
  }

  private isAtLeastOneUserSelected(users: IManageUsersUser[]): boolean {
    const selectedUsersLength = this.getSelectedUsers(users).length;
    const atLeastOneUserIsSelected = selectedUsersLength !== 0;

    // set shared state for isAtLeastOneUserSelected
    this.sharedState.atLeastOneUserIsSelected = atLeastOneUserIsSelected;

    return atLeastOneUserIsSelected;
  }

  private isEveryUserSelected(users: IManageUsersUser[], atLeastOneUserIsSelected?: boolean): boolean {
    const everyUserIsSelected =
      atLeastOneUserIsSelected &&
      every(users, (user: IManageUsersUser) => {
        const ignore = !user.filtered || !user.editable;

        if (ignore) {
          return true;
        } else {
          return user.selected;
        }
      });

    return everyUserIsSelected;
  }
}
